"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GridDemo_1 = require("./GridDemo");
exports.default = GridDemo_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridDemo/index.js
// module id = 1360
// module chunks = 8